//LORO PARQUE
import {SpecialExcursion as SpecialExcursion1010} from './Excursions/1010/excursion';  // Loro Parque + Bus
import {SpecialExcursion as SpecialExcursion1011} from './Excursions/1011/excursion';  // Loro Parque
import {SpecialExcursion as SpecialExcursion1070} from './Excursions/1070/excursion';  // Siam Park + Bus
import {SpecialExcursion as SpecialExcursion1131} from './Excursions/1131/excursion';  // Loro Parque Bus Express
import {SpecialExcursion as SpecialExcursion1132} from './Excursions/1132/excursion';  // Twin Ticket Express + Bus [EsBONO]
import {SpecialExcursion as SpecialExcursion3100} from './Excursions/3100/excursion';  // Siam Park
import {SpecialExcursion as SpecialExcursion3101} from './Excursions/3101/excursion';  // Twin Ticket [EsBONO]
import {SpecialExcursion as SpecialExcursion3102} from './Excursions/3102/excursion';  // Twin Ticket + Bus [EsBONO]
import {SpecialExcursion as SpecialExcursion3103} from './Excursions/3103/excursion';  // Siam day and night
import {SpecialExcursion as SpecialExcursion3107} from './Excursions/3107/excursion';  // Siam day and night residentes
import {SpecialExcursion as SpecialExcursion3113} from './Excursions/3113/excursion';  // Twin Ticket Premium [EsBONO]
import {SpecialExcursion as SpecialExcursion6000} from './Excursions/6000/excursion';  // Poema del mar
import {SpecialExcursion as SpecialExcursion6008} from './Excursions/6008/excursion';  // Siam Night
import {SpecialExcursion as SpecialExcursion6031} from './Excursions/6031/excursion';  // Poema del mar residente
import {SpecialExcursion as SpecialExcursion6032} from './Excursions/6032/excursion';  // Siam Park Cabaña VIP [EsBONO]
import {SpecialExcursion as SpecialExcursion6033} from './Excursions/6033/excursion';  // Siam Park Premium  [EsBONO]
import {SpecialExcursion as SpecialExcursion6034} from './Excursions/6034/excursion';  // Siam Park All Inclusive [EsBONO]
import {SpecialExcursion as SpecialExcursion6035} from './Excursions/6035/excursion';  // Siam Park Champagne Club [EsBONO]
import {SpecialExcursion as SpecialExcursion6041} from './Excursions/6041/excursion';  // Siam Park Casa VIP [EsBONO]
import {SpecialExcursion as SpecialExcursion6042} from './Excursions/6042/excursion';  // Siam Park Villa VIP [EsBONO]
import {SpecialExcursion as SpecialExcursion6052} from './Excursions/6052/excursion';  // Loro Parque + Almuerzo [EsBONO]
import {SpecialExcursion as SpecialExcursion6053} from './Excursions/6053/excursion';  // Loro Parque + BRUNELLIS [EsBONO]
import {SpecialExcursion as SpecialExcursion6054} from './Excursions/6054/excursion';  // Siam Park. Entrada + menú [EsBONO]
import {SpecialExcursion as SpecialExcursion6059} from './Excursions/6059/excursion';  // Siam Park residente
import {SpecialExcursion as SpecialExcursion6063} from './Excursions/6063/excursion';  // Loro Parque + DIAMOND TOUR [EsBONO]
import {SpecialExcursion as SpecialExcursion6064} from './Excursions/6064/excursion';  // Loro Parque + PREMIUM TOUR [EsBONO]
import {SpecialExcursion as SpecialExcursion8009} from './Excursions/8009/excursion';  // Siam Park + bus [norte]
import {SpecialExcursion as SpecialExcursion8010} from './Excursions/8010/excursion';  // Siam Night + bus [norte]

//TELEFERICO VULCANO
import {SpecialExcursion as SpecialExcursion1120} from './Excursions/1120/excursion'; // Visita guiada diurna al Observatorio del Teide
import {SpecialExcursion as SpecialExcursion1124} from './Excursions/1124/excursion'; // Observación astronómica
import {SpecialExcursion as SpecialExcursion2052} from './Excursions/2052/excursion'; // Teide Tour Volcano + Teleférico (sur)
import {SpecialExcursion as SpecialExcursion2059} from './Excursions/2059/excursion'; // Astronomic Tour con recogidas desde el sur
import {SpecialExcursion as SpecialExcursion2060} from './Excursions/2060/excursion'; // Astronomic Tour con recogidas desde el norte
import {SpecialExcursion as SpecialExcursion2065} from './Excursions/2065/excursion'; // Ascenso Al Pico + teleferico
import {SpecialExcursion as SpecialExcursion2066} from './Excursions/2066/excursion'; // Teide Tour Volcano + Teleférico (Playa Paraíso y Los Gigantes)
import {SpecialExcursion as SpecialExcursion2067} from './Excursions/2067/excursion'; // Teide Tour Volcano + Teleférico (Playa Paraíso y Los Gigantes)
import {SpecialExcursion as SpecialExcursion2073} from './Excursions/2073/excursion'; // Ascenso Al Pico + teleferico (Norte) 168
import {SpecialExcursion as SpecialExcursion2079} from './Excursions/2079/excursion'; // Teide Tour + Teleférico (Norte)
import {SpecialExcursion as SpecialExcursion5588} from './Excursions/5588/excursion'; // Sunset & Stars (sin cena)  + bus (SUR)
import {SpecialExcursion as SpecialExcursion5590} from './Excursions/5590/excursion'; // Sunset & Stars (sin cena) + bus (NORTE)
import {SpecialExcursion as SpecialExcursion6023} from './Excursions/6023/excursion'; // Subida al Pco del Teide VIP con Teleferico
import {SpecialExcursion as SpecialExcursion6024} from './Excursions/6024/excursion'; // Subida al Pico de El Teide VIP a pie
import {SpecialExcursion as SpecialExcursion6026} from './Excursions/6026/excursion'; // Teide tour Vulcano + sin teleferico
import {SpecialExcursion as SpecialExcursion6036} from './Excursions/6036/excursion'; // Teide tour Vulcano + sin teleferico (NORTE)
import {SpecialExcursion as SpecialExcursion6038} from './Excursions/6038/excursion'; // Excursion al Teide de noche  (SUR)
import {SpecialExcursion as SpecialExcursion6039} from './Excursions/6039/excursion'; // Excursion al Teide de noche  (NORTE)
import {SpecialExcursion as SpecialExcursion6055} from './Excursions/6055/excursion'; // Excursion al Teide de noche + picnic  (NORTE)
import {SpecialExcursion as SpecialExcursion6056} from './Excursions/6056/excursion'; // Excursion al Teide de noche + picnic  (SUR)
import {SpecialExcursion as SpecialExcursion6057} from './Excursions/6057/excursion'; // Astronomic tour + picnic (SUR)
import {SpecialExcursion as SpecialExcursion6058} from './Excursions/6058/excursion'; // Astronomic tour + picnic (NORTE)
import {SpecialExcursion as SpecialExcursion8027} from './Excursions/8027/excursion'; // Teide Tour + Teleférico (Santa Cruz)
import {SpecialExcursion as SpecialExcursion8028} from './Excursions/8028/excursion'; // Teide tour  sin teleferico (Santa Cruz)

import {SpecialExcursion as SpecialExcursion5000} from './Excursions/5000/excursion';

const SpecialExcursions = {
  1010: SpecialExcursion1010,
  1011: SpecialExcursion1011,
  1070: SpecialExcursion1070,
  1120: SpecialExcursion1120,
  1124: SpecialExcursion1124,
  1131: SpecialExcursion1131,
  1132: SpecialExcursion1132,
  2052: SpecialExcursion2052,
  2059: SpecialExcursion2059,
  2060: SpecialExcursion2060,
  2065: SpecialExcursion2065,
  2066: SpecialExcursion2066,
  2067: SpecialExcursion2067,
  2073: SpecialExcursion2073,
  2079: SpecialExcursion2079,
  3100: SpecialExcursion3100,
  3101: SpecialExcursion3101,
  3102: SpecialExcursion3102,
  3103: SpecialExcursion3103,
  3107: SpecialExcursion3107,
  3113: SpecialExcursion3113,
  5588: SpecialExcursion5588,
  5590: SpecialExcursion5590,
  6000: SpecialExcursion6000,
  6008: SpecialExcursion6008,
  6023: SpecialExcursion6023,
  6024: SpecialExcursion6024,
  6026: SpecialExcursion6026,
  6031: SpecialExcursion6031,
  6032: SpecialExcursion6032,
  6033: SpecialExcursion6033,
  6034: SpecialExcursion6034,
  6035: SpecialExcursion6035,
  6036: SpecialExcursion6036,
  6038: SpecialExcursion6038,
  6039: SpecialExcursion6039,
  6041: SpecialExcursion6041,
  6042: SpecialExcursion6042,
  6052: SpecialExcursion6052,
  6053: SpecialExcursion6053,
  6054: SpecialExcursion6054,
  6055: SpecialExcursion6055,
  6056: SpecialExcursion6056,
  6057: SpecialExcursion6057,
  6058: SpecialExcursion6058,
  6059: SpecialExcursion6059,
  6063: SpecialExcursion6063,
  6064: SpecialExcursion6064,
  8009: SpecialExcursion8009,
  8010: SpecialExcursion8010,
  8027: SpecialExcursion8027,
  8028: SpecialExcursion8028

  //5000: SpecialExcursion5000
}
export default SpecialExcursions;